import SortableTableHeader from './SortableTableHeader'
// Uncomment the below to migrate to stateful component
// import SortableTableHeaderContainer from './SortableTableHeaderContainer'

export { SortableTableHeader }
export default SortableTableHeader
// Uncomment the below to migrate to stateful component
// export { SortableTableHeader, SortableTableHeaderContainer }
// export default SortableTableHeaderContainer



// WEBPACK FOOTER //
// ./src/components/SortableTableHeader/index.js